var _path, _path2, _path3, _path4, _path5, _path6, _path7, _rect, _rect2, _rect3, _circle, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _circle2, _rect11, _rect12, _rect13, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _circle3, _path14, _circle4, _circle5, _path15, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg74(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 900,
    height: 600,
    viewBox: "0 0 900 600",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "transparent",
    d: "M0 0h900v600H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M713.335 354.846c3.727 68.663-130.514 208.281-295.976 156.604-76.954-24.037-70.436-63.932-128.952-116.511-34.878-31.338-84.993-55.035-98.931-100.587-12.041-39.317-4.657-81.578 16.218-109.066 46.948-61.819 141.727-104.15 235.114-6.749 93.387 97.4 262.897-.777 272.527 176.309z",
    fill: "url(#a)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M676.537 203.494c-13.058 23.303-41.654 26.505-87.468 22.076-34.456-3.336-65.876-5.918-100.334-24.705-24.118-13.14-43.21-30.919-57.144-48.186-15.1-18.706-36.175-40.054-25.844-61.264 14.199-29.135 96.308-53.673 176.039-13.545 87.584 44.093 107.524 102.848 94.751 125.624z",
    fill: "url(#b)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M344.192 488.495c-30.419-42.556-61.573-87.786-102.359-110.064-42.069-22.99-49.828-8.821-52.74 13.706-2.912 22.526 10.068 75.898 67.481 106.266 57.427 30.376 116.081 29.921 87.618-9.908z",
    fill: "url(#c)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M695.814 485.589H202.062c-14.598 0-26.437-11.838-26.437-26.436V149.784c0-14.598 11.839-26.437 26.437-26.437h493.752c14.599 0 26.437 11.839 26.437 26.437v309.369c0 14.598-11.838 26.436-26.437 26.436z",
    fill: "#fff",
    stroke: "#E1E4E5",
    strokeWidth: 4
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M722.251 149.784a8.34 8.34 0 0 1-8.34 8.339H183.965a8.34 8.34 0 0 1-8.34-8.339c0-14.598 11.839-26.437 26.437-26.437h493.752c14.599 0 26.437 11.839 26.437 26.437z",
    fill: "#fff",
    stroke: "#E1E4E5",
    strokeWidth: 4
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M202.115 148.089a6.107 6.107 0 1 0 0-12.213 6.107 6.107 0 0 0 0 12.213zm25.445 0a6.107 6.107 0 1 0 0-12.213 6.107 6.107 0 0 0 0 12.213zm24.428 0a6.107 6.107 0 1 0 0-12.213 6.107 6.107 0 0 0 0 12.213z",
    fill: "#E1E4E5"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 137,
    y: 207.013,
    width: 229.744,
    height: 88.106,
    rx: 11.013,
    fill: "#666AF6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 203.051,
    y: 234.07,
    width: 140.06,
    height: 10.345,
    rx: 5.173,
    fill: "#fff"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 203.051,
    y: 257.148,
    width: 90.721,
    height: 10.345,
    rx: 5.173,
    fill: "#fff"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 174.402,
    cy: 250.782,
    r: 16.712,
    fill: "#fff"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 486,
    y: 307,
    width: 206.559,
    height: 192.859,
    rx: 11.013,
    fill: "#666AF6"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 545.385,
    y: 438.821,
    width: 125.925,
    height: 9.301,
    rx: 4.651,
    fill: "#fff"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 545.017,
    y: 419.764,
    width: 81.148,
    height: 9.485,
    rx: 4.742,
    transform: "rotate(-90 545.017 419.764)",
    fill: "#fff"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 586.118,
    y: 419.764,
    width: 81.148,
    height: 9.485,
    rx: 4.742,
    transform: "rotate(-90 586.118 419.764)",
    fill: "#fff"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 627.219,
    y: 419.764,
    width: 81.148,
    height: 9.485,
    rx: 4.742,
    transform: "rotate(-90 627.219 419.764)",
    fill: "#fff"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 545.385,
    y: 459.571,
    width: 81.565,
    height: 9.301,
    rx: 4.651,
    fill: "#fff"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 566.094,
    y: 419.764,
    width: 52.694,
    height: 8.431,
    rx: 4.215,
    transform: "rotate(-90 566.094 419.764)",
    fill: "#fff"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 607.195,
    y: 419.764,
    width: 52.694,
    height: 8.431,
    rx: 4.215,
    transform: "rotate(-90 607.195 419.764)",
    fill: "#fff"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 648.296,
    y: 419.764,
    width: 52.694,
    height: 8.431,
    rx: 4.215,
    transform: "rotate(-90 648.296 419.764)",
    fill: "#fff"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 519.628,
    cy: 453.846,
    r: 15.025,
    fill: "#fff"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 528.933,
    y: 147.064,
    width: 232.067,
    height: 86.531,
    rx: 18,
    fill: "#fff",
    stroke: "#E1E4E5",
    strokeWidth: 4
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 594.802,
    y: 172.866,
    width: 143.915,
    height: 10.63,
    rx: 5.315,
    fill: "#E1E4E5"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 594.802,
    y: 196.58,
    width: 93.218,
    height: 10.63,
    rx: 5.315,
    fill: "#E1E4E5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M564.345 213.151c-12.513 0-22.658-10.289-22.658-22.978 0-12.689 10.145-22.977 22.658-22.977 12.513 0 22.658 10.288 22.658 22.977s-10.145 22.978-22.658 22.978z",
    fill: "#666AF6"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m572.323 186.344-9.571 10.212-5.747-6.126",
    stroke: "#fff",
    strokeWidth: 3.568,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M529.283 287.709c-1.706-.629-3.152-1.477-4.149-2.15a1.626 1.626 0 0 1-.316-2.415 1.63 1.63 0 0 1 2.142-.283c.826.556 2.038 1.272 3.45 1.792l.158.058c3.363 1.191 6.254.7 8.591-1.46 1.298-1.2 2.438-2.293 3.444-3.257 4.447-4.265 6.897-6.614 11.576-7.227 4.773-.625 7.908 2.927 10.674 6.062 1.985 2.249 3.861 4.373 5.782 4.281l.42-.02.253.128c.327.083 3.56.713 8.201-5.15 2.908-3.675 5.66-5.652 8.414-6.042 1.835-.261 3.398.202 4.743.887a1.622 1.622 0 0 1 .623 2.344 1.614 1.614 0 0 1-2.09.543c-1.988-1.041-4.71-1.3-9.134 4.289-5.651 7.139-10.196 6.654-11.581 6.282-3.324-.008-5.736-2.742-8.072-5.388-2.444-2.769-4.753-5.386-7.807-4.985-3.619.474-5.539 2.314-9.745 6.347a247.946 247.946 0 0 1-3.487 3.298c-3.276 3.027-7.421 3.754-11.99 2.103-.034-.014-.067-.025-.1-.037z",
    fill: "#E1E4E5"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M594.92 277.714c-1.706-.629-3.152-1.477-4.149-2.151a1.625 1.625 0 0 1-.316-2.414 1.63 1.63 0 0 1 2.142-.284c.826.557 2.038 1.273 3.45 1.793l.158.058c3.363 1.191 6.254.7 8.591-1.46 1.298-1.2 2.438-2.293 3.444-3.257 4.447-4.265 6.897-6.614 11.576-7.227 4.773-.625 7.908 2.927 10.674 6.062 1.985 2.249 3.861 4.373 5.782 4.281l.42-.02.253.128c.327.083 3.56.713 8.201-5.15 2.908-3.675 5.66-5.652 8.414-6.043 1.835-.26 3.398.203 4.743.888a1.622 1.622 0 0 1 .623 2.344 1.614 1.614 0 0 1-2.09.543c-1.988-1.041-4.71-1.3-9.134 4.289-5.651 7.139-10.196 6.654-11.581 6.282-3.324-.009-5.736-2.742-8.072-5.388-2.444-2.77-4.753-5.386-7.807-4.986-3.619.474-5.539 2.315-9.745 6.348a253.597 253.597 0 0 1-3.487 3.298c-3.276 3.027-7.421 3.754-11.99 2.103-.034-.014-.067-.025-.1-.037z",
    fill: "#E1E4E5"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M227.999 332.342 216.76 343.57l-5.46-5.444m41.05-11.157h33.216m-32.957 16.479h54.93m-79.54 27.346-11.239 11.228-5.46-5.444m41.05-11.157h33.216M252.609 381.9h54.93m0 38.451H252.35m55.189-16.479h-54.93",
    stroke: "#E1E4E5",
    strokeWidth: 5.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M219.649 425.845c6.068 0 10.987-4.919 10.987-10.986 0-6.068-4.919-10.986-10.987-10.986-6.067 0-10.986 4.918-10.986 10.986 0 6.067 4.919 10.986 10.986 10.986z",
    stroke: "#E1E4E5",
    strokeWidth: 5.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m370.272 332.342-11.239 11.228-5.46-5.444m41.049-11.157h33.217m-32.958 16.479h54.931m-79.54 27.346-11.239 11.228-5.46-5.444m41.049-11.157h33.217M394.881 381.9h54.931m-.001 38.451h-55.189m55.19-16.479h-54.931",
    stroke: "#E1E4E5",
    strokeWidth: 5.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M361.922 425.845c6.068 0 10.986-4.919 10.986-10.986 0-6.068-4.918-10.986-10.986-10.986-6.067 0-10.986 4.918-10.986 10.986 0 6.067 4.919 10.986 10.986 10.986z",
    stroke: "#E1E4E5",
    strokeWidth: 5.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 660.489,
    cy: 261.218,
    r: 6.16,
    transform: "rotate(10.422 660.489 261.218)",
    fill: "#E1E4E5"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M512.74 242.705h-2.171a.948.948 0 0 1-.947-.947v-2.171c0-.525.427-.947.947-.947h2.171a.95.95 0 0 1 .947.947v2.171a.944.944 0 0 1-.947.947zm-7.526 0h-2.171a.95.95 0 0 1-.947-.947v-2.171c0-.525.427-.947.947-.947h2.171a.95.95 0 0 1 .947.947v2.171a.95.95 0 0 1-.947.947zm-7.531 0h-2.17a.951.951 0 0 1-.948-.947v-2.171c0-.525.427-.947.948-.947h2.17c.521 0 .948.427.948.947v2.171a.946.946 0 0 1-.948.947zm-7.526 0h-2.17a.951.951 0 0 1-.948-.947v-2.171c0-.525.427-.947.948-.947h2.17c.525 0 .952.427.952.947v2.171a.957.957 0 0 1-.952.947zm-7.526 0h-2.171a.952.952 0 0 1-.952-.947v-2.171c0-.525.427-.947.952-.947h2.171a.95.95 0 0 1 .947.947v2.171a.95.95 0 0 1-.947.947zm22.307-8.207h-2.17a.951.951 0 0 1-.948-.947v-2.175c0-.521.427-.948.948-.948h2.17c.525 0 .948.427.948.948v2.17a.947.947 0 0 1-.948.952zm-7.526 0h-2.171a.95.95 0 0 1-.947-.947v-2.175c0-.521.427-.948.947-.948h2.171c.521 0 .948.427.948.948v2.17a.947.947 0 0 1-.948.952zm-7.526 0h-2.171a.952.952 0 0 1-.952-.947v-2.175c0-.521.427-.948.952-.948h2.171c.52 0 .947.427.947.948v2.17a.952.952 0 0 1-.947.952zm7.797 17.024h-2.17a.951.951 0 0 1-.948-.948v-2.17c0-.525.427-.948.948-.948h2.17c.521 0 .948.427.948.948v2.17a.946.946 0 0 1-.948.948zm-7.526 0h-2.17a.951.951 0 0 1-.948-.948v-2.17c0-.525.427-.948.948-.948h2.17c.525 0 .952.427.952.948v2.17a.957.957 0 0 1-.952.948zm-15.356-42.541h-2.171a.948.948 0 0 1-.947-.947v-2.171c0-.525.427-.947.947-.947h2.171a.95.95 0 0 1 .947.947v2.171a.944.944 0 0 1-.947.947zm-7.526 0h-2.171a.952.952 0 0 1-.948-.947v-2.171c0-.525.428-.947.948-.947h2.171a.95.95 0 0 1 .947.947v2.171a.95.95 0 0 1-.947.947zm-7.531 0h-2.171a.95.95 0 0 1-.947-.947v-2.171c0-.525.427-.947.947-.947h2.171c.521 0 .948.427.948.947v2.171a.946.946 0 0 1-.948.947zm-7.526 0h-2.171a.95.95 0 0 1-.947-.947v-2.171c0-.525.427-.947.947-.947h2.171c.525 0 .952.427.952.947v2.171a.958.958 0 0 1-.952.947zm-7.526 0h-2.171a.952.952 0 0 1-.952-.947v-2.171c0-.525.427-.947.952-.947h2.171a.95.95 0 0 1 .947.947v2.171a.95.95 0 0 1-.947.947zm22.307-8.207h-2.171a.95.95 0 0 1-.947-.947v-2.175c0-.521.427-.948.947-.948h2.171c.525 0 .947.427.947.948v2.17a.946.946 0 0 1-.947.952zm-7.526 0h-2.171a.95.95 0 0 1-.947-.947v-2.175c0-.521.427-.948.947-.948h2.171c.52 0 .947.427.947.948v2.17a.946.946 0 0 1-.947.952zm-7.526 0h-2.171a.952.952 0 0 1-.952-.947v-2.175c0-.521.427-.948.952-.948h2.171c.52 0 .947.427.947.948v2.17a.952.952 0 0 1-.947.952zm7.797 17.024h-2.171a.952.952 0 0 1-.947-.948v-2.171c0-.524.427-.947.947-.947h2.171c.521 0 .948.427.948.947v2.171a.947.947 0 0 1-.948.948zm-7.526 0h-2.171a.952.952 0 0 1-.947-.948v-2.171c0-.524.427-.947.947-.947h2.171c.525 0 .952.427.952.947v2.171a.96.96 0 0 1-.952.948z",
    fill: "#E1E4E5"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 413.114,
    cy: 256.775,
    r: 24.954,
    transform: "rotate(75 413.114 256.775)",
    fill: "url(#d)"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 413.114,
    cy: 256.775,
    transform: "rotate(75 413.114 256.775)",
    fill: "#fff",
    r: 17.824
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M419.573 280.879a24.954 24.954 0 1 1 6.018-45.715l-3.743 6.484a17.456 17.456 0 0 0-16.459-.539 17.465 17.465 0 0 0-3.792 28.799 17.475 17.475 0 0 0 16.038 3.74l1.938 7.231z",
    fill: "#666AF6"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 552.889,
    y1: 766.422,
    x2: 301.784,
    y2: -366.479,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 588.574,
    y1: 354.521,
    x2: 472.192,
    y2: -168.453,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 310.226,
    y1: 628.197,
    x2: 210.423,
    y2: 166.659,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 414.179,
    y1: 309.71,
    x2: 412.64,
    y2: 177.53,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg74);
export default __webpack_public_path__ + "static/media/74.a41e68549e65c5ff0ff04f1dfeb74924.svg";
export { ForwardRef as ReactComponent };